export default __webpack_public_path__ + "static/media/864.92003f25.png";